module.exports = __webpack_public_path__ + "static/media/N. Lenore, Willits, CA (2 Buildings)5.29e7d041.jpg";